/* 还款计划信息接口 */

import axios from 'axios';
export default {
  getRepayPlanDetail (params) { // 获取还款计划详情接口
    return axios.get('/loanform/finance/loanItemFinanceRepay/getRepayPlanDetail.ht', {
      params: {
        financePayId: params.financePayId,
        financePayPeriod: params.financePayPeriod,
        pageCurrent: params.pageCurrent,
        pageSize: params.pageSize,
        repayStatusCode: params.repayStatusCode
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/repaymentInfo.js